import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

class TutorBookingMenu extends Component {
    render() {
        const { activeClass } = this.props;
        return (<div className="col-md-12 mb-4">
            <div className="post-box p-0 book-tab">
                <ul className="list-group list-group-horizontal">
                    <li><NavLink to="/tutor/bookings" className={`list-group-item ${(activeClass && activeClass === 'UserBooking') ? 'active' : ''}`}>My Bookings</NavLink></li>
                    <li><NavLink to="/tutor/completed-sessions" className={`list-group-item ${(activeClass && activeClass === 'UserSessions') ? 'active' : ''}`}>Completed Sessions</NavLink></li>
                    <li><NavLink to="/tutor/cancelled-sessions" className={`list-group-item ${(activeClass && activeClass === 'CancelledSessions') ? 'active' : ''}`}>Cancelled Sessions</NavLink></li>
                    <li><NavLink to="/tutor/disputed-sessions" className={`list-group-item ${(activeClass && activeClass === 'DisputedSessions') ? 'active' : ''}`}>Disputed Sessions</NavLink></li>
                </ul>
            </div>
        </div>);
    }
}

export default TutorBookingMenu;